"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnounceForm = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../../../app");
const announce_1 = require("../../../model/announce");
const venue_1 = require("../../../model/venue");
const helpers_1 = require("../../../utils/helpers");
const duration_picker_1 = require("../../../widgets/duration_picker");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const notification_center_1 = require("../../../widgets/notification_center");
const right_panel_1 = require("../../../widgets/right_panel");
const announce_table_1 = require("./announce_table");
const moment = require("moment");
function getDateValue(ann) {
    if (ann.starts_at) {
        return moment.tz(ann.starts_at, app_1.App.BOOKING_TIMEZONE).format("YYYY-MM-DD");
    }
    else {
        return undefined;
    }
}
function setDateValueOneDay(str, obj) {
    let date;
    if (str) {
        date = moment.tz(str, "YYYY-MM-DD", app_1.App.BOOKING_TIMEZONE);
        const start = moment.tz(obj.starts_at, app_1.App.BOOKING_TIMEZONE);
        const end = moment.tz(obj.ends_at, app_1.App.BOOKING_TIMEZONE);
        obj.starts_at = start.date(date.date()).month(date.month()).year(date.year()).tz('UTC').format();
        obj.ends_at = end.date(date.date()).month(date.month()).year(date.year()).tz('UTC').format();
    }
    else {
        obj.starts_at = undefined;
        obj.ends_at = undefined;
    }
}
function setTime(obj, key, hours, minutes) {
    let date = moment.tz(obj[key], app_1.App.BOOKING_TIMEZONE);
    obj[key] = date.hours(hours).minutes(minutes).seconds(0).tz('UTC').format();
    return obj[key];
}
function getDayValue(obj, mode) {
    let time;
    if (obj[mode] === undefined) {
        time = moment.tz(obj[mode], app_1.App.BOOKING_TIMEZONE).hours(mode === 'starts_at' ? 8 : 22).minutes(0);
    }
    else {
        time = moment.tz(obj[mode], app_1.App.BOOKING_TIMEZONE);
    }
    return 60 * time.hours() + time.minutes();
}
function validateForm(form) {
    const obj = form.obj;
    if (obj.venue_id == null)
        return false;
    if (obj.title == null || obj.title == "")
        return false;
    if (obj.content == null || obj.content == "")
        return false;
    if (obj.starts_at == null || obj.ends_at == null)
        return false;
    return true;
}
const LIONEL_ANNOUNCE = `Bonjour $CLIENT_NAME,
Vous avez une réservation le $BOOKING_DATE à $BOOKING_HOUR au Centre Sésame. Il n’y aura pas d’accueil physique à cette heure.
Voici les codes pour accéder au centre :
  1. Porte de l’immeuble sur le boulevard : $DOOR_CODE_BUILDING
  2. Porte vitrée après l’entrée de l’immeuble : $DOOR_CODE_BUILDING_2 (1 et 2 nécessaires seulement le samedi à partir de 12h et le dimanche)
  3. Porte du centre au premier étage : XXXX.
Vous pouvez ainsi entrer dans le centre, vérifier sur l’interface à l’aide de votre téléphone le cabinet qui vous a été attribué (onglet « Réserver ») et attendre votre client à l’accueil pour lui ouvrir la porte.
Ces informations vous sont communiquées par mail et sur l’interface (onglet « Tableau de bord »).
En cas de besoin, vous pouvez appeler Lionel 06 80 47 25 97.
Merci et bonne séance.`;
const CECILE_ANNOUNCE = `Bonjour $CLIENT_NAME,
Vous avez une réservation le $BOOKING_DATE à $BOOKING_HOUR au Centre Sésame. Il n’y aura pas d’accueil physique à cette heure.
Voici les codes pour accéder au centre :
  1. Porte de l’immeuble sur le boulevard : $DOOR_CODE_BUILDING
  2. Porte vitrée après l’entrée de l’immeuble : $DOOR_CODE_BUILDING_2 (1 et 2 nécessaires seulement le samedi à partir de 12h et le dimanche)
  3. Porte du centre au premier étage : XXXX.
Vous pouvez ainsi entrer dans le centre, vérifier sur l’interface à l’aide de votre téléphone le cabinet qui vous a été attribué (onglet « Réserver ») et attendre votre client à l’accueil pour lui ouvrir la porte.
Ces informations vous sont communiquées par mail et sur l’interface (onglet « Tableau de bord »).
En cas de besoin, vous pouvez appeler Cécile 06 87 55 22 62.
Merci et bonne séance.`;
function clickDoorgate(form, content) {
    form.obj.content = content;
    form.obj.title = "Code de la porte";
}
function renderOneDay(form) {
    return [
        (0, mithril_1.default)("input.input", {
            type: "date",
            value: getDateValue(form.obj),
            onchange: (evt) => { setDateValueOneDay(evt.target.value, form.obj); }
        }),
        (0, form_for_1.columns)((0, helpers_1.button)("Tout le matin", { onclick: (evt) => {
                evt.preventDefault();
                setTime(form.obj, 'starts_at', 8, 0);
                setTime(form.obj, 'ends_at', 14, 0);
            }, class: "" }), (0, helpers_1.button)("Toute l'après-midi", { onclick: (evt) => {
                evt.preventDefault();
                setTime(form.obj, 'starts_at', 14, 0);
                setTime(form.obj, 'ends_at', 22, 0);
            }, class: "" }), (0, helpers_1.button)("Toute la journée", { onclick: (evt) => {
                evt.preventDefault();
                setTime(form.obj, 'starts_at', 8, 0);
                setTime(form.obj, 'ends_at', 22, 0);
            }, class: "" })),
        (0, form_for_1.columns)((0, mithril_1.default)(duration_picker_1.DurationPicker, {
            value: getDayValue(form.obj, 'starts_at'),
            minDuration: 0,
            maxDuration: 24 * 60,
            step: app_1.App.BOOKING_STEP,
            onchange: (v) => {
                setTime(form.obj, "starts_at", Math.floor(v / 60), v % 60);
            }
        }), (0, mithril_1.default)(duration_picker_1.DurationPicker, {
            value: getDayValue(form.obj, 'ends_at'),
            minDuration: 0,
            maxDuration: 24 * 60,
            step: app_1.App.BOOKING_STEP,
            onchange: (v) => {
                setTime(form.obj, "ends_at", Math.floor(v / 60), v % 60);
            }
        }))
    ];
}
function renderMultiDays(form) {
    return (0, form_for_1.columns)((0, mithril_1.default)("div", "Du:"), (0, mithril_1.default)("input.input", {
        type: "date",
        value: moment(form.obj.starts_at).format("YYYY-MM-DD"),
        onchange: (evt) => { form.obj.starts_at = moment(evt.target.value).tz('UTC').format(); }
    }), (0, mithril_1.default)("div", "Au:"), (0, mithril_1.default)("input.input", {
        type: "date",
        value: moment(form.obj.ends_at).format("YYYY-MM-DD"),
        onchange: (evt) => { form.obj.ends_at = moment(evt.target.value).tz('UTC').format(); }
    }));
}
function renderTime(form) {
    switch (form.obj.range_type) {
        case "multiple_day":
            return renderMultiDays(form);
        case "one_day":
            return renderOneDay(form);
        default:
            return;
    }
}
function renderForm(form) {
    return [
        form.errorBlock(),
        form.fieldset("Lieu et date", {}, form.selectField("Établissement", "venue_id", (0, venue_1.venuesForSelect)(), { class: "is-fullwidth" }), (0, form_for_1.columns)(form.radio("Une journée", "range_type", { value: "one_day" }), form.radio("Plusieurs jours", "range_type", { value: "multiple_day" })), renderTime(form)),
        form.fieldset("Contenu", {}, (0, mithril_1.default)("div.content.buttons", (0, mithril_1.default)("button.button.is-primary", { onclick: (evt) => { evt.preventDefault(); clickDoorgate(form, LIONEL_ANNOUNCE); } }, "Modele 'Code Porte Lionel'"), (0, mithril_1.default)("button.button.is-primary", { onclick: (evt) => { evt.preventDefault(); clickDoorgate(form, CECILE_ANNOUNCE); } }, "Modele 'Code Porte Cecile'")), form.field("Titre", "title", "text"), form.textarea("Contenu", "content")),
    ];
}
exports.AnnounceForm = {
    announce: {},
    active: false,
    reset() {
        this.announce = {};
    },
    show(announce) {
        if (announce) {
            this.announce = announce;
            if (announce.id) {
                // Reload the contract
                announce_1.AnnounceProvider.show(this.announce.id).then((announce) => {
                    this.announce = announce;
                });
            }
        }
        else {
            this.reset();
        }
        this.active = true;
    },
    title() {
        if (this.announce.id !== undefined) {
            return `Editer annonce #${this.announce.id}`;
        }
        else {
            return `Nouvelle annonce`;
        }
    },
    view(_vnode) {
        let form = (0, form_for_1.formFor)(this.announce, announce_1.AnnounceProvider, (form) => {
            return (0, modal_1.modalCard)({
                title: this.title(),
                content: renderForm(form),
                foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit("Créer", {
                    disabled: !validateForm(form),
                    onsubmit: (obj) => {
                        notification_center_1.Notification.success(`L'annonce ${obj.id} a bien été créée. `, (0, mithril_1.default)("a", { href: "#", onclick: () => { right_panel_1.RightPanel.open("announces", obj.id, "show"); } }, "Afficher"));
                        exports.AnnounceForm.active = false;
                        announce_table_1.AnnounceTable.fetch();
                    }
                })),
                isActive: exports.AnnounceForm.active,
                onClose: () => { exports.AnnounceForm.active = false; }
            });
        });
        return form;
    }
};
